<template>
  <div class="opple-ability-ui-com-input">
    <el-input-number
      v-model="value"
      :min="item.Min"
      :max="item.Max"
      :step="precision || 1"
      :precision="decimalPlaces"
      :disabled="item.Readonly"
      class="ip_input input_left"
    />
    <span class="opple-ability-ui-com-input_unit">{{ displayUnit }}</span>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      value: undefined
    };
  },

  computed: {
    precision() {
      return this.item.UI?.Precision;
    },
    decimalPlaces() {
      const s = String(this.precision || '');
      return s.includes('.') ? s.split('.')[1].length : 0;
    },
    displayUnit() {
      return this.item.UI?.ParaUnit || this.item.ParaUnit || ''
    },
  },

  mounted() {
    const { DefaultValue } = this.item;
    if (DefaultValue !== undefined && DefaultValue !== null && DefaultValue !== '') {
      this.value = Number(DefaultValue);
    }
  },

  methods: {
    getData() {
      const { KeyId } = this.item;
      const val = this.precision
        ? Math.round(this.value / this.precision)
        : this.value;

      return {
        Key: KeyId,
        Values: `${val}`.split(',')
      };
    }
  },
};
</script>

<style lang="scss">
.opple-ability-ui-form {
  .opple-ability-ui-com-input {
    position: relative;
    display: flex;

    .ip_input {
      position: relative;
      right: auto;
    }

    &_unit {
      position: absolute;
      right: -44px;
      font-size: 12px;
    }
  }
}
</style>
